import BaseService from '../../BaseService.js'

export default class LogLevelService extends BaseService {
  constructor() {
    super('loglevel')
  }
}
